import { FrameHealthDimension } from 'features/Health/containers/FrameHealthChartContainer/types/frameHealthDimension';

const getCount = (dataPoint: FrameHealthDimension) =>
  dataPoint.ok + dataPoint.lowDelivery + dataPoint.inError + dataPoint.mia + dataPoint.deactivated;

export const getTotalFrameCountPerDimension = (chartData: FrameHealthDimension[]) => {
  const totals: Map<String, number> = new Map<String, number>();

  chartData.forEach((frameHealthDimension) => {
    const count = getCount(frameHealthDimension);
    totals.set(frameHealthDimension.dimension, count);
  });
  return totals;
};
